/* eslint-disable jsx-a11y/anchor-is-valid */
// @ts-nocheck
import React, { useState, useRef, useEffect } from "react";
import ListBoxItem from "./ListBoxItem";
import { Form } from "react-bootstrap";
import Editable from "react-bootstrap-editable";
import autoAnimate from "@formkit/auto-animate";
import { API_URL } from "../constants";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";


const TIER_ENDPOINTS = {
    tier1: '/location-twos/',
    tier2: '/location-threes/',
    tier3: '/location-fours/',
    tier4: '/location-fives/',
    tier5: '/location-sixes/',
};

const ListBox = (props) => {
    const animateListItem = useRef();
    const animateTestItem = useRef();
    const [showModal, setShowModal] = useState(false);
    const [tierDetails, setTierDetails] = useState({ title: '', certificate_date: new Date(), documents: [] });


    const title = useRef();


    const handleConfigurationModal = (id) => {

        getTierDetails(props.mode, id);

    }


    const parseDate = (value) => {
        const dateArray = value.split("/");
        return new Date(parseInt(dateArray[2]), parseInt(dateArray[1]) - 1, parseInt(dateArray[0]));
    }

    const getTierDetails = async (mode, id) => {
        const endpoint = Object.prototype.hasOwnProperty.call(TIER_ENDPOINTS, mode)
            ? TIER_ENDPOINTS[mode]
            : null;
        if (!endpoint) {
            console.error("Unauthorized tier mode:", mode);
            return;
        }

        const sanitizedId = String(id).replace(/[^a-zA-Z0-9_-]/g, "");
        if (!sanitizedId) {
            console.error("Invalid ID format");
            return;
        }

        // URL is built from the hardcoded API_URL constant, an endpoint from the
        // TIER_ENDPOINTS allowlist above, and an alphanumeric-sanitized id.
        // nosemgrep: javascript-ssrf-rule-node_ssrf
        const response = await fetch(`${API_URL}${endpoint}${sanitizedId}`);
        if (response.ok) {
            const tierData = await response.json();


            setTierDetails(tierData);
            setShowModal(true);
        }
    }


    const handleCreateItem = (e) => {
        e.preventDefault();
        // @ts-ignore
        props.onHandleCreateItem(title.current.value);
        // @ts-ignore
        title.current.value = '';


    }


    useEffect(() => { animateListItem.current && autoAnimate(animateListItem.current) }, [animateListItem])
    useEffect(() => { animateTestItem.current && autoAnimate(animateTestItem.current) }, [animateTestItem])

    const handleDeleteItem = (id) => {
        props.handleDeleteItem(props.mode, id)
    }

    const handleEditItem = (id, name, itemIsHazard) => {
        props.handleEditItem(id, name, itemIsHazard)
    }

    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }

        const startIndex = result.source.index;
        const endIndex = result.destination.index;

        // Reorder the items in the props.lists array
        const reorderedItems = Array.from(props.lists);
        const [removed] = reorderedItems.splice(startIndex, 1);
        reorderedItems.splice(endIndex, 0, removed);

        // Update the order property of the reordered items
        const updatedItems = reorderedItems.map((item, index) => ({
            ...item,
            order: index + 1,
        }));

        // Call the handler function to update the order in your parent component
        console.log(updatedItems)
        props.handleReorderItems(updatedItems);
    };

    return (<>
        <div className="card shadow">
            <div className="card-body p-0">
                <div className="card-title pencil-icon p-3 pb-0 mb-0">
                    <Editable initialValue={props.title} onSubmit={(value) => props.onEditTitle(value, props.mode)} className="d-flex" mode="inline" />
                </div>

                {
                    props.selected && (<>
                        <Form.Group className="form-group p-3 mb-0">
                            <div className="input-group">
                                <Form.Control type="text" ref={title} className="form-control mb-0" placeholder="Enter name..." aria-label="item" aria-describedby="basic-addon2" />
                                <div className="input-group-append">
                                    <button className="btn btn-primary btn-icon mb-0 h-100 z-0" type="button" onClick={(e) => { handleCreateItem(e) }}><i className="mdi mdi-plus-circle"></i></button>
                                </div>
                            </div>
                        </Form.Group>
                        <div className="h-250" ref={animateListItem}>
                            <DragDropContext onDragEnd={onDragEnd}>
                                <Droppable droppableId="list">
                                    {(provided) => (
                                        <div ref={provided.innerRef} {...provided.droppableProps}>
                                            {props.lists.map((item, index) => (
                                                <Draggable key={item.id} draggableId={item.id} index={index}>
                                                    {(provided) => (
                                                        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                            <ListBoxItem
                                                                key={item.id}
                                                                onHandleEditItem={handleEditItem}
                                                                onHandleDelete={handleDeleteItem}
                                                                selectedId={props.selectedItem.id}
                                                                data={item}
                                                                showHazard={props.showHazard}
                                                                onHandleSelect={(id) => props.handleSelect(id)}
                                                            />
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>


                        </div>
                    </>)
                }

                {!props.selected && (<p className="p-3">Please select a item from left pane to continue</p>)}


            </div>

        </div>


    </>);
}

export default ListBox;
